// kvd
//   PAKeyGeneratorClient allows us to generate unique keys for records..
//     Call Loopback REST backend (Custom Remote Method).. to return keys using a named sequences
//
//
import * as _ from "lodash";
import * as AsyncLock from "async-lock";
import axios from "axios";
import { IKeyGenerator, IKeyGeneratorOptions, IKeyGeneratorSpecs } from "./lib/libIF";
import { MD5 } from "object-hash";

interface IKeyPoolEntry {
    KeyPool: any[];
    RequestCount: number;
}

class PAKeyGeneratorClient
    implements IKeyGenerator {
    private _end_point: string;
    private _end_point_hash: string;
    private _sequence_name: string;
    private _requestCount: number;


    private static RequestLock: any;
    private _keyGenSpecs: IKeyGeneratorSpecs;

    //use a static dictionary of sequence to keys in pool to conserve keys across ESDataStore instances
    private static dctKeyPoolByEndpointHashSequenceID: { [endpointHash: string]: { [sequenceID: string]: IKeyPoolEntry } };

    private static getKeyPoolEntry(pool_hash: string, sequence_name: string): IKeyPoolEntry {
        if (!(sequence_name in PAKeyGeneratorClient.dctKeyPoolByEndpointHashSequenceID[pool_hash])) {
            PAKeyGeneratorClient.dctKeyPoolByEndpointHashSequenceID[pool_hash][sequence_name] = {
                KeyPool: [],
                RequestCount: 0
            };
        }

        return PAKeyGeneratorClient.dctKeyPoolByEndpointHashSequenceID[pool_hash][sequence_name];
    }

    constructor(opts: IKeyGeneratorOptions) {

        this._end_point = opts.end_point;
        this._end_point_hash = MD5(this._end_point);
        this._keyGenSpecs = opts.keyGenSpecs;
        this._sequence_name = opts.keyGenSpecs.sequence_name;
        this._requestCount = 0;

        if (!PAKeyGeneratorClient.RequestLock)
            PAKeyGeneratorClient.RequestLock = new AsyncLock({ maxPending: 20000 });

        if (!PAKeyGeneratorClient.dctKeyPoolByEndpointHashSequenceID)
            PAKeyGeneratorClient.dctKeyPoolByEndpointHashSequenceID = {};

        if (!PAKeyGeneratorClient.dctKeyPoolByEndpointHashSequenceID[this._end_point_hash])
            PAKeyGeneratorClient.dctKeyPoolByEndpointHashSequenceID[this._end_point_hash] = {};

    }

    public getNewId(opts?: any): Promise<number | string> {
        const self = this;

        return new Promise<number | string>((resolve, reject) => {
                self.getNewIds(1, opts)
                    .then(function(arrResponse) {
                        resolve(arrResponse[0]);
                    })
                    .catch(function(err) {
                        reject(err);
                    });
            }
        );

    }

    public getNewIds(iKeyCount: number, opts?: any): Promise<number[] | string[]> {
        const self = this;

        iKeyCount = Math.max(1, iKeyCount);
        let sEndPoint = self._end_point;
        return new Promise<number[] | string[]>((resolve, error) => {

            PAKeyGeneratorClient.RequestLock.acquire("serverRequestLock",
                (done: any) => {
                    let keyPoolEntry = PAKeyGeneratorClient.getKeyPoolEntry(self._end_point_hash, self._sequence_name);
                    if (keyPoolEntry.KeyPool.length > iKeyCount) {
                        done(null, keyPoolEntry.KeyPool.splice(0, iKeyCount));
                    } else {
                        // Use Axios to get Keys
                        self._requestCount++;
                        keyPoolEntry.RequestCount++;

                        axios.get(sEndPoint,
                            {
                                params: {
                                    sequence_name: self._sequence_name,
                                    count: Math.max(self._keyGenSpecs.keyPoolSize, iKeyCount, 1)
                                },
                                headers: { "Cache-Control": "no-cache, no-store, must-revalidate" }
                            }
                        ).then(function(resp: any) {
                            const responseArray = resp.data;
                            if (_.isArray(responseArray)) {
                                // Return first iKeyCount Values
                                const returnArray = responseArray.splice(0, iKeyCount);
                                keyPoolEntry.KeyPool.push(...responseArray);
                                done(null, returnArray);
                            } else {
                                console.log(JSON.stringify(resp));
                                done(`Unable to parse GenKey Web Response: ${JSON.stringify(resp)}`);
                            }
                        }).catch(function(err: any) {
                            done("Unable to obtain Keys from Server." + JSON.stringify(err));
                        });
                    }

                }).then((results: number[] | string[]) => {
                resolve(results);
            }).catch((err: any) => {
                error(err);
            });

        });
    }

    get SequenceName(): string {
        return this._keyGenSpecs.sequence_name;
    }

    get KeyGenSpecs(): IKeyGeneratorSpecs {
        return this._keyGenSpecs;
    }

    get RequestCount(): number {
        return this._requestCount;
    }

    get EndPoint(): string {
        return this._end_point;
    }

}

export { PAKeyGeneratorClient };
